(function () {
  var root = document;

  /* ---------- reveal (reuses the same .dc-reveal pattern) ------------------
     A plain IntersectionObserver alone can miscalculate on this page: it's an
     image-heavy product grid, and if the observer's initial check runs before
     images/fonts finish loading and settle the layout, elements can be judged
     "not intersecting" and never fire again — leaving the product grid stuck
     at opacity:0. The scroll-driven sweep() below is a defensive fallback
     that re-checks real bounding boxes and force-reveals anything already
     within view, run once immediately and again on every scroll/resize. */
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var targets = [].slice.call(root.querySelectorAll('.dc-reveal'));
  function show(el) { el.style.opacity = '1'; el.style.transform = 'none'; }
  if (!reduce) targets.forEach(function (el) { el.style.opacity = '0'; el.style.transform = 'translateY(22px)'; });
  var io = null;
  if (!reduce && 'IntersectionObserver' in window) {
    io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { show(e.target); io.unobserve(e.target); } }); }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
    targets.forEach(function (el) { io.observe(el); });
  } else { targets.forEach(show); targets = []; }
  function sweep() {
    var lim = window.innerHeight * 0.94;
    targets = targets.filter(function (el) {
      if (el.getBoundingClientRect().top >= lim) return true;
      show(el); if (io) io.unobserve(el); return false;
    });
  }
  var raf = null;
  window.addEventListener('scroll', function () { if (raf) return; raf = requestAnimationFrame(function () { raf = null; sweep(); }); }, { passive: true });
  window.addEventListener('resize', sweep);
  requestAnimationFrame(sweep);
  setTimeout(sweep, 700);

  /* ---------- filter form: auto-submit on change (native Shopify facets) --- */
  var form = root.querySelector('[data-dc-filterform]');
  if (form) {
    [].forEach.call(form.querySelectorAll('input[type="checkbox"]'), function (input) {
      input.addEventListener('change', function () { form.submit(); });
    });
    var priceTimers = null;
    [].forEach.call(form.querySelectorAll('[data-dc-price-input]'), function (input) {
      input.addEventListener('change', function () {
        clearTimeout(priceTimers);
        priceTimers = setTimeout(function () { form.submit(); }, 300);
      });
    });

    /* sort pills set the hidden sort_by input then submit the same form */
    var sortInput = form.querySelector('[data-dc-sort-input]');
    [].forEach.call(root.querySelectorAll('[data-dc-sort]'), function (b) {
      b.addEventListener('click', function () {
        if (sortInput) sortInput.value = b.getAttribute('data-dc-sort');
        form.submit();
      });
    });

    /* collapsible filter groups */
    [].forEach.call(form.querySelectorAll('[data-dc-fgrp-toggle]'), function (btn) {
      btn.addEventListener('click', function () {
        var grp = btn.closest('.dc-fgrp');
        if (grp) grp.classList.toggle('is-collapsed');
      });
    });
  }

  /* ---------- mobile filter drawer ------------------------------------- */
  var side = root.querySelector('[data-dc-side]');
  var openBtn = root.querySelector('[data-dc-filters-open]');
  var closeBtn = root.querySelector('[data-dc-filters-close]');
  if (side && openBtn) {
    openBtn.addEventListener('click', function () { side.classList.add('is-open'); document.body.style.overflow = 'hidden'; });
  }
  if (side && closeBtn) {
    closeBtn.addEventListener('click', function () { side.classList.remove('is-open'); document.body.style.overflow = ''; });
  }

  /* ---------- quick add (single-variant products only) --------------------- */
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-dc-quickadd]');
    if (!b || b.disabled) return;
    var id = b.getAttribute('data-dc-quickadd');
    b.disabled = true;
    var original = b.textContent;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        b.textContent = 'Added';
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        root.querySelectorAll('.dh-count').forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
        setTimeout(function () { b.textContent = original; b.disabled = false; }, 1400);
      })
      .catch(function () { b.textContent = 'Try again'; setTimeout(function () { b.textContent = original; b.disabled = false; }, 1400); });
  });
})();
